export default "__VITE_ASSET__DUkoZ4bv__"